module.exports = __webpack_public_path__ + "img/nav6@2x.01dd890a.png";